import Icon from 'veui/components/Icon'
import { IconOrder } from 'dls-icons-vue'

Icon.register('order', IconOrder)
